export function redirect(url) {
    window.location.assign(url);
}
export function getParams() {
    return new URLSearchParams(window.location.search);
}
